import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.9987 3.64669C5.05318 3.64669 2.66536 6.0345 2.66536 8.98002C2.66536 11.9255 5.05318 14.3134 7.9987 14.3134C10.9442 14.3134 13.332 11.9255 13.332 8.98002C13.332 6.0345 10.9442 3.64669 7.9987 3.64669ZM1.33203 8.98002C1.33203 5.29812 4.3168 2.31335 7.9987 2.31335C11.6806 2.31335 14.6654 5.29812 14.6654 8.98002C14.6654 12.6619 11.6806 15.6467 7.9987 15.6467C4.3168 15.6467 1.33203 12.6619 1.33203 8.98002Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.9987 4.81335C8.36689 4.81335 8.66536 5.11183 8.66536 5.48002V8.31335H11.4987C11.8669 8.31335 12.1654 8.61183 12.1654 8.98002C12.1654 9.34821 11.8669 9.64669 11.4987 9.64669H7.9987C7.63051 9.64669 7.33203 9.34821 7.33203 8.98002V5.48002C7.33203 5.11183 7.63051 4.81335 7.9987 4.81335Z"
    }, null, -1)
  ])))
}
export default { render: render }